import { StatusChip } from '../../../common/components';
import {
  COMPLETED_PROJECT_TYPE,
  STATUS_LABELS,
  STATUS_PRESETS,
} from '../constants/notificationsConstants';

const RECIPIENT_TYPE_LABELS = {
  internal_user: 'Usuario interno',
  subscriber: 'Suscriptor',
  module_audience: 'Usuarios del módulo',
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  return new Date(value).toLocaleString('es-AR');
};

export const getRecipientDisplayValue = (recipient) =>
  recipient.recipient_label ||
  recipient.recipient_uuid ||
  RECIPIENT_TYPE_LABELS[recipient.recipient_type] ||
  recipient.recipient_type ||
  '';

export const getRecipientLabels = (event) => {
  const recipients = Array.isArray(event.recipients) ? event.recipients : [];
  const labels = recipients.map(getRecipientDisplayValue).filter(Boolean);

  if (labels.length > 0) {
    return [...new Set(labels)];
  }

  return [event.recipient_user_uuid, event.recipient_subscriber_uuid].filter(Boolean);
};

export const truncateText = (value, maxLength) => {
  const text = value || '-';

  if (text.length <= maxLength) {
    return text;
  }

  return `${text.slice(0, maxLength)}...`;
};

const lowerFirst = (value) => (value ? `${value.charAt(0).toLowerCase()}${value.slice(1)}` : '');

const getMissingText = (event) => {
  const labels = Array.isArray(event.payload?.missing_labels)
    ? event.payload.missing_labels
    : [];

  return labels.map(lowerFirst).filter(Boolean).join(', ');
};

export const getNotificationMessageText = (event) => {
  if (event.notification_type === COMPLETED_PROJECT_TYPE) {
    const missingText = getMissingText(event);

    if (missingText) {
      return `Falta: ${missingText}`;
    }
  }

  return event.message || event.title || '-';
};

export const getNotificationRuleText = (event) => event.rule_name || event.notification_type || '-';

export const getNotificationPriorityText = (event) => event.is_urgent ? 'Urgente' : event.severity || '-';

export const getNotificationStatusLabel = (value) => STATUS_LABELS[value] || value || '-';

export const statusChip = (value) => (
  <StatusChip
    label={getNotificationStatusLabel(value)}
    status={STATUS_PRESETS[value]?.status || 'neutral'}
    size="small"
  />
);
